module.exports = __webpack_public_path__ + "media/images/bottle-pattern-43f33f46215d52243b657235b6afc711.svg";